import { ReactComponent as AccountLarge } from './accountLarge.svg'
export default AccountLarge
